import React from 'react';
import { useParams } from 'react-router-dom';
import ProductPageTemplate from '../components/ProductPageTemplate';
import { findProductBySlug } from '../data/catalog';
import NotFound from './NotFound';

export default function ProductBySlug() {
  const { slug } = useParams();
  const product = findProductBySlug(slug);
  if (!product) return <NotFound />;
  return <ProductPageTemplate productData={product} />;
}
